import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useIsDesktop } from "../hooks/index.js";
import { Tooltip } from "../Tooltip/index.js";
import { Box } from "../Box/index.js";
import { Typography } from "../Typography/index.js";
import { Icon } from "../Icon/index.js";
const InputTooltip = (t0)=>{
    const $ = c(17);
    let { title, description, subText, placement, children: t1 } = t0;
    const children = void 0 === t1 ? null : t1;
    const isDesktop = useIsDesktop();
    if (!placement) placement = isDesktop ? "right" : "top";
    let t2;
    if ($[0] !== title) {
        t2 = title && /*#__PURE__*/ jsx(Box, {
            children: /*#__PURE__*/ jsx(Typography, {
                variant: "subtitle1",
                color: "text.dark.primary",
                children: title
            })
        });
        $[0] = title;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== description) {
        t3 = description && /*#__PURE__*/ jsx(Box, {
            children: /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                color: "text.dark.primary",
                children: description
            })
        });
        $[2] = description;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== children) {
        t4 = !!children && /*#__PURE__*/ jsx(Box, {
            mt: "8",
            children: children
        });
        $[4] = children;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== subText) {
        t5 = subText && /*#__PURE__*/ jsx(Box, {
            mt: "8",
            children: /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                color: "text.light.tertirary",
                children: subText
            })
        });
        $[6] = subText;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ jsxs(Box, {
            children: [
                t2,
                t3,
                t4,
                t5
            ]
        });
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ jsx(Box, {
            width: "fit-content",
            children: /*#__PURE__*/ jsx(Icon, {
                name: "help_outline",
                size: "20",
                color: "stroke.secondary",
                "data-testid": "help-icon-test-id"
            })
        });
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== placement || $[15] !== t6) {
        t8 = /*#__PURE__*/ jsx(Box, {
            height: 20,
            className: "aqa_input_tooltip",
            testId: "input-tooltip-test-id",
            children: /*#__PURE__*/ jsx(Tooltip, {
                placement: placement,
                title: t6,
                children: t7
            })
        });
        $[14] = placement;
        $[15] = t6;
        $[16] = t8;
    } else t8 = $[16];
    return t8;
};
export { InputTooltip };
